var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.comp,{tag:"component",attrs:{"awardData":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }